import { PayRank } from './PayRank'
import { withPayRank } from './withPayRank'

const ConnectedPayRank = withPayRank(PayRank)

export { ConnectedPayRank as PayRank }
